import _extends from '@babel/runtime/helpers/extends';
import React__default, { useContext } from 'react';
import styled, { css } from 'styled-components';
import { f as focusOutline } from '../../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { R as RadioGroupContext } from '../RadioGroupContext-CZtwmSGz.js';
import { a as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { T as Text } from '../../Text/Text-CO4HftGt.js';

const InputWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40026394__sc-1yio0qi-0"
})(["align-content:center;display:flex;padding-block:", ";", ""], ({
  theme
}) => theme.spacing.xxxxsmall.default, isMobile(css(["padding-block:", ";"], ({
  theme
}) => theme.spacing.xxxxsmall.mobile)));
const StyledInput = /*#__PURE__*/styled('input').withConfig({
  componentId: "sc-storm-ui-40026394__sc-1yio0qi-1"
})(["&&{@media (prefers-reduced-motion:no-preference){transition:color 100ms ease,background-color 100ms ease,border-color 100ms ease,box-shadow 100ms ease;}vertical-align:auto;bottom:auto;position:relative;appearance:none;margin:0;cursor:pointer;box-sizing:border-box;width:", ";height:", ";background-color:", ";border-radius:", ";border-width:", ";border-style:solid;border-color:", ";:checked{background-color:", ";border-color:transparent;}:focus-visible{", "}:hover{background-color:", ";border-color:", ";}:active{background-color:", ";border-color:", ";}:disabled{cursor:not-allowed;background-color:", ";border-color:", ";:checked{background-color:", ";}}:checked::after{content:'';position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:", ";height:", ";background-color:", ";border-radius:50%;}}"], ({
  theme
}) => theme.radioButton.width, ({
  theme
}) => theme.radioButton.height, ({
  theme
}) => theme.selectableWidget.backgroundColor.default, ({
  theme
}) => theme.border.radius.round, ({
  theme
}) => theme.border.width.default, ({
  theme
}) => theme.border.color.medium.default, ({
  theme
}) => theme.selectableWidget.backgroundColor.selected, focusOutline, ({
  theme
}) => theme.selectableWidget.backgroundColor.hover, ({
  theme
}) => theme.border.color.medium.hover, ({
  theme
}) => theme.selectableWidget.backgroundColor.active, ({
  theme
}) => theme.border.color.medium.active, ({
  theme
}) => theme.selectableWidget.backgroundColor.unavailableInverted, ({
  theme
}) => theme.border.color.medium.unavailable, ({
  theme
}) => theme.selectableWidget.backgroundColor.unavailableSelected, ({
  theme
}) => theme.radioButton.dot.width, ({
  theme
}) => theme.radioButton.dot.height, ({
  theme
}) => theme.color.gray[0]);
const RadioButtonLabel = /*#__PURE__*/styled('label').withConfig({
  componentId: "sc-storm-ui-40026394__sc-1yio0qi-2"
})(["cursor:", ";box-sizing:border-box;display:flex;flex-direction:row;align-items:flex-start;padding:0;margin:0;font-weight:unset;gap:", ";", ""], ({
  disabled
}) => disabled ? 'not-allowed' : 'pointer', ({
  theme
}) => theme.selectableWidget.controlLabelGap.default, isMobile(css(["gap:", ";"], ({
  theme
}) => theme.selectableWidget.controlLabelGap.mobile)));
const RadioButton = ({
  id,
  disabled = false,
  inline = false,
  isChecked,
  inputRef,
  label,
  onChange,
  value = '',
  taktId,
  taktValue,
  ...rest
}) => {
  const {
    handleRadioChange,
    name,
    isGroupDisabled,
    isGroupInline,
    selectedValue
  } = useContext(RadioGroupContext);
  const handleChange = event => {
    handleRadioChange === null || handleRadioChange === void 0 || handleRadioChange(event);
    onChange === null || onChange === void 0 || onChange(event);
  };
  const radioId = name ? `${name}-${value}` : id;
  const checked = selectedValue ? selectedValue === value : isChecked;
  const isDisabled = isGroupDisabled || disabled;
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('radio-button')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(RadioButtonLabel, _extends({
    disabled: isDisabled,
    inline: isGroupInline || inline,
    htmlFor: radioId
  }, getDataTaktAttributes({
    taktIdSuffix: 'label'
  })), /*#__PURE__*/React__default.createElement(InputWrapper, null, /*#__PURE__*/React__default.createElement(StyledInput, _extends({}, getDataTaktAttributes({
    contextOnlyTaktValues: {
      value,
      checked
    }
  }), rest, {
    type: "radio",
    id: radioId,
    name: name,
    checked: checked,
    onChange: handleChange,
    value: value,
    disabled: isDisabled,
    ref: inputRef
  }))), /*#__PURE__*/React__default.createElement(Text, {
    color: isDisabled ? 'unavailable' : 'default'
  }, label)));
};

export { RadioButtonLabel as R, RadioButton as a };
//# sourceMappingURL=RadioButton-BL7xfTly.js.map
